export default __webpack_public_path__ + "static/media/pharrell6.02102613.jpeg";